import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'addproject-modalcomponent',
  template: require('./addprojectmodal.component.html'),
  styles: [require('./addprojectmodal.component.scss')]
})
export class AddProjectModalComponent {
  closeResult: boolean;
  @Input('title') title: any;
  @Output() result = new EventEmitter();

  constructor(private service: NgbModal) {}

  close(res: boolean) {
    this.result.next(res);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/modal/addprojectmodal.component.ts